/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_UpdatedInputs */

const en_admin_roles_updated = /** @type {(inputs: Admin_Roles_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role updated`)
};

const zh_admin_roles_updated = /** @type {(inputs: Admin_Roles_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色已更新`)
};

/**
* | output |
* | --- |
* | "Role updated" |
*
* @param {Admin_Roles_UpdatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_roles_updated = /** @type {((inputs?: Admin_Roles_UpdatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_UpdatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_roles_updated(inputs)
	return zh_admin_roles_updated(inputs)
});
export { admin_roles_updated as "admin.roles.updated" }